import React from 'react';

export default function Resume() {
  return (
    <section className="container">
      <h2>My Resume</h2>
      <a className="btn" href="/resume.pdf" download>📄 Download Resume</a>
    </section>
  );
}
